import { type PropsWithChildren, useState } from 'react';
import { useRegisterAPIService } from '@elfsight/widget-js-api';
import { RADIO_PLAYER_SERVICE_NAME } from '../../../constants';
import {
  type CreateMetadataFetcherProps,
  createMetadataFetcher
} from '../../../helpers';
import {
  type CustomFetchers,
  CustomMetadataFetchersContext
} from './CustomMetadataFetchersContext';

export function RadioPlayerCustomMetadataFetchersProvider({
  children
}: PropsWithChildren) {
  const [customMetadataFetchers, setCustomMetadataFetchers] =
    useState<CustomFetchers>({});

  useRegisterAPIService(
    RADIO_PLAYER_SERVICE_NAME,
    () => ({
      setMetadataFetcher(
        id: string,
        { url, parser, headers }: CreateMetadataFetcherProps
      ) {
        if (!id || !url || !parser) {
          return;
        }

        setCustomMetadataFetchers((previousMetadataFetchers) => ({
          ...previousMetadataFetchers,
          [id]: (props) =>
            createMetadataFetcher({
              ...props,
              url,
              parser,
              headers
            })
        }));
      }
    }),
    []
  );

  return (
    <CustomMetadataFetchersContext.Provider value={{ customMetadataFetchers }}>
      {children}
    </CustomMetadataFetchersContext.Provider>
  );
}
